var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    {
      staticClass: "mt-0"
    },
    [
      _c(
        "v-col",
        {
          staticClass: "d-block",
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "v-alert",
            {
              staticClass: "py-3 px-1 mb-2 white--text",
              attrs: {
                color: "error lighten-1"
              },
              scopedSlots: _vm._u([
                {
                  key: "prepend",
                  fn: function fn() {
                    return [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mx-2 d-none d-sm-block white--text",
                          attrs: {
                            size: "24"
                          }
                        },
                        [_vm._v("mdi-alert")]
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "append",
                  fn: function fn() {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            elevation: "0",
                            "aria-label": "Dismiss.",
                            disabled: _vm.loading
                          },
                          on: {
                            click: _vm.noticeDismiss
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "white--text"
                            },
                            [_vm._v("mdi-close")]
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ]),
              model: {
                value: _vm.model,
                callback: function callback($$v) {
                  _vm.model = $$v
                },
                expression: "model"
              }
            },
            [
              _vm._v(
                " We do not have a valid payment method on file for your account. Please "
              ),
              _c(
                "router-link",
                {
                  staticClass: "white--text fw-bold underline",
                  attrs: {
                    to: {
                      name: "profile_info"
                    }
                  }
                },
                [_vm._v(" update your payment method ")]
              ),
              _vm._v(". ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }